var plot_number = "plot 22211 Phase 4";
var city_country = "Gaborone - Botswana";
export default {
  name: "page_info",
  phone_number: "+267 73512090", //nyd get the right phone number, and values for below staff
  mobile_number: "+267 73512090",
  facebook: "https://facebook.com/busyug",
  twitter: "https://twitter.com/busyug",
  instagram: "https://facebook.com/busyug",
  youtube: "https://youtube.com/busyug",
  linkedin: "https://linkedin.com/busyug",
  whatsapp: "https://web.whatsapp.com/+26773512090",
  email_address: "info@botswanaservices.com",
  // website: "",
  fax: "",
  box_number: "P.O.Box 70335, phase 4 - gaborone",
  physical_address: plot_number + ", " + city_country,
  plot_number: plot_number,
  city_country: city_country,
  embedde_map: `<iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14501.10107685095!2d25.872198255468266!3d-24.683062393143278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ebb5bfc7b5957b7%3A0x17efa97e71de16fd!2sSolidcare%20Services!5e0!3m2!1sen!2sbw!4v1601164003989!5m2!1sen!2sbw"
    width="100%"
    height="450"
    frameborder="0"
    style="border: 0"
    allowfullscreen=""
    aria-hidden="false"
    tabindex="0"
  ></iframe>`,
  get_contacts_list() {
    return [{
      icon: "mdi-phone-classic",
      label: "Officce Line:",
      value: this.phone_number,
      remark: "from monday - sat, working hours",
      protocol: "tel:"
    }, {
      icon: "mdi-cellphone-basic",
      label: "Mobile Number:",
      value: this.mobile_number,
      remark: "after working hours (5:00 pm - midnight)",
      protocol: "tel:"
    }, {
      icon: "mdi-send",
      label: "Box Number:",
      value: this.box_number,
      remark: "",
      protocol: ""
    }, {
      icon: "mdi-email-variant",
      label: "Email Address :",
      value: this.email_address,
      remark: "",
      protocol: "mailto:"
    }, {
      icon: "mdi-fax",
      label: "Fax :",
      value: this.fax,
      remark: "",
      protocol: "fax:"
    }];
  },
  get_social_media_links() {
    return [{
      icon: "mdi-facebook",
      label: "Facebook:",
      value: this.facebook,
      remark: "",
      protocol: ""
    }, {
      icon: "mdi-whatsapp",
      label: "Whatsapp:",
      value: this.whatsapp,
      remark: "",
      protocol: ""
    }, {
      icon: "mdi-twitter",
      label: "Twitter:",
      value: this.twitter,
      remark: "",
      protocol: ""
    }, {
      icon: "mdi-instagram",
      label: "Instagram:",
      value: this.instagram,
      remark: "",
      protocol: ""
    }, {
      icon: "mdi-youtube",
      label: "Youtube:",
      value: this.youtube,
      remark: "",
      protocol: ""
    }, {
      icon: "mdi-linkedin",
      label: "LinkedIn:",
      value: this.linkedin,
      remark: "",
      protocol: ""
    }];
  },
  center_width_class: "wdth-8-12p",
  teams: [{
    name: "Administration",
    section_id: "team_admin",
    description: "This is a very briefed summary about the importance of this section of the team, what kind of work is done and so many other things, like what what",
    members: [{
      profile_picture: "https://images.generated.photos/cEUhZLVjuYGzPDnP_zALLt1yo4uQHOHCfn3El_grg-w/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzA5OTc4NDUuanBn.jpg",
      name: "Mr. Lame Gare",
      role: "C.E.O",
      description: "This is a description for this persons role on this project",
      facebook_url: "",
      instagram_url: "",
      email_address: "",
      bg_url: "https://picsum.photos/510/300?random"
    },{
      profile_picture: "https://images.generated.photos/CY3xoqQSCeWXaxhbYH-tVVn7EW6YOamNhSqaENJVaQs/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzAwNjc3MTEuanBn.jpg",
      name: "Mrs. Thespi",
      role: "Project Manager",
      description: "This is a description for this persons role on this project",
      facebook_url: "",
      instagram_url: "",
      email_address: "",
      bg_url: "https://picsum.photos/510/300?random"
    }]
  },{
    name: "Marketing",
    section_id: "team_marketing",
    description: "This is a very briefed summary about the importance of this section of the team, what kind of work is done and so many other things, like what what",
    members: [{
      profile_picture: "https://images.generated.photos/xgq-Jc4oCjEgMsXq21Wt86NPifHlmQgvE7XMk5DFYzk/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzA1ODc4NDEuanBn.jpg",
      name: "Lorato Luudo",
      role: "Head Of Marketing",
      description: "This is a description for this persons role on this project",
      facebook_url: "",
      instagram_url: "",
      email_address: "",
      bg_url: "https://picsum.photos/510/300?random"
    },{
      profile_picture: "https://images.generated.photos/7YYHuCoady4SctF9XooqpKb9JS_ifUKtjQBnxYmAxAU/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzA1ODIxMDkuanBn.jpg",
      name: "Kenilwa Good Girl",
      role: "Marketing",
      description: "This is a description for this persons role on this project",
      facebook_url: "",
      instagram_url: "",
      email_address: "",
      bg_url: "https://picsum.photos/510/300?random"
    }]
  },{
    name: "Support",
    section_id: "team_support",
    description: "This is a very briefed summary about the importance of this section of the team, what kind of work is done and so many other things, like what what",
    members: [{
      profile_picture: "https://images.generated.photos/kY0OOWAC5eDVrjAUhSj_VY0mX7pq_shOFQnmmpXIb2o/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzA2MjEyNzUuanBn.jpg",
      name: "Reginal Baebe",
      role: "System Administrator",
      description: "This is a description for this persons role on this project",
      facebook_url: "",
      instagram_url: "",
      email_address: "",
      bg_url: "https://picsum.photos/510/300?random"
    },{
      profile_picture: "https://images.generated.photos/OkBkWImJyVJSvYRB7pF8699zHdKcTWvhI4apX_YU_fU/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzAzOTI0MDkuanBn.jpg",
      name: "Kylo Wakalalera",
      role: "User Engament",
      description: "This is a description for this persons role on this project",
      facebook_url: "",
      instagram_url: "",
      email_address: "",
      bg_url: "https://picsum.photos/510/300?random"
    }]
  },{
    name: "Technical",
    section_id: "team_technical",
    description: "This is a very briefed summary about the importance of this section of the team, what kind of work is done and so many other things, like what what",
    members: [{
      profile_picture: "https://images.generated.photos/iHlr2LIzpqzVGAPTLinCDJHv7AywKPQqpKDpq-t6JmM/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzA4MTE2OTAuanBn.jpg",
      name: "Nyola Mike",
      role: "System Developer",
      description: "This is a description for this persons role on this project",
      facebook_url: "",
      instagram_url: "",
      email_address: "",
      bg_url: "https://picsum.photos/510/300?random"
    },{
      profile_picture: "https://images.generated.photos/h0h6DHA6_5JSrZzYYmoMDUa3TSIr2dQ-Qs9DNJBbyTA/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzAzMjQxNjAuanBn.jpg",
      name: "Lemogang Donovan",
      role: "System Developer",
      description: "This is a description for this persons role on this project",
      facebook_url: "",
      instagram_url: "",
      email_address: "",
      bg_url: "https://picsum.photos/510/300?random"
    }]
  },{
    name: "Sales",
    section_id: "team_sales",
    description: "This is a very briefed summary about the importance of this section of the team, what kind of work is done and so many other things, like what what",
    members: [{
      profile_picture: "https://images.generated.photos/L0G0CbYMJenHTKHIHu-bspYEdd-FUfCT5Xs7MKdnloM/rs:fit:512:512/Z3M6Ly9nZW5lcmF0/ZWQtcGhvdG9zL3Yz/XzAyNjI2NzAuanBn.jpg",
      name: "Bakang Sweerty",
      role: "Sales & Business",
      description: "This is a description for this persons role on this project",
      facebook_url: "",
      instagram_url: "",
      email_address: "",
      bg_url: "https://picsum.photos/510/300?random"
    }]
  }],
  maximum_hash_tags: 10,
  registration_goal: 2000,
  ad_goal: 50,
  ad_platforms: [
    {
      id: 1,
      name: "web_app",
      label: "Desktop Web Application",
      pages: [
        {
          id: 1,
          name: "home",
          label: "Home Page",
          sections: [{
            id: 1,
            name: "left_column",
            label: "Left Column Section"
          }],
        },
        {
          id: 2,
          name: "public_business_view",
          label: "Public Business View Page",
          sections: [{
            id: 2,
            name: "left_column",
            label: "Left Column Section"
          },{
            id: 2,
            name: "right_column",
            label: "Right Column Section"
          }],
        },
        {
          id: 3,
          name: "promotions",
          label: "Public Promtions View Page",
          sections: [{
            id: 2,
            name: "left_column",
            label: "Left Column Section"
          },{
            id: 2,
            name: "right_column",
            label: "Right Column Section"
          },{
            id: 3,
            name: "center_column",
            label: "Center Column Featured Section"
          }],
        }
      ]
    },
    {
      id: 2,
      name: "mobile_responsive_web_app",
      label: "Responsive Mobile View",
      pages: [
        {
          id: 3,
          name: "home",
          label: "Home Page",
          sections: [],
        },
        {
          id: 4,
          name: "public_business_view",
          label: "Public Business View Page",
          sections: [],
        }
      ]
    },
  ],
  promotions_page_featured_size: 5,
  promotions_page_viwed_size: 5,
  promotions_page_on_going_size: 5,
  promotions_page_on_overdue_size: 5,
  promotions_most_viewed_min_value: 30,
  promotions_group_page_size: 5,
  search_results_page_size: 14
}